module.exports = __webpack_public_path__ + "fonts/fa-solid-900.ff8d9f8.ttf";